import {NgModule} from "@angular/core";
import {Routes, RouterModule} from "@angular/router";

import {AuthGuardService} from "../_services";

//Components...
import {HomeComponent} from "./home/home.component";
// import { LeadsListComponent } from './leads-list/leads-list.component';
import {ProjectListComponent} from "./projects/project-list-old/project-list.component";
import {CalendarComponent} from "./calendar/calendar.component";
import {EditProfileComponent} from "./edit-profile/edit-profile.component";
import {ContactsListComponent} from "./contacts/contacts-list/contacts-list.component";
import {FilesListComponent} from "./files-list/files-list.component";
import {ProjectDetailComponent} from "./projects/project-detail/project-detail.component";
import {ContactDetailComponent} from "./contacts/contact-detail/contact-detail.component";
import {PmfdlComponent} from "./projects/pmfdl/pmfdl.component";
import {SigninsListComponent} from "./signins/signins-list/signins-list.component";
import {ClaimSigninComponent} from "./signins/claim-signin/claim-signin.component";
import {ProjectList2Component} from "./projects/project-list2/project-list2.component";
import {NodeComponent} from "./node/node.component";
import {ClaimMarketingListEntryComponent} from "./claim-marketing-list-entry/claim-marketing-list-entry.component";

const routes: Routes = [
  {
    path: "home",
    component: HomeComponent,
    data: {
      layoutName: "layoutOne",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "contacts",
    component: ContactsListComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "contacts/:contactType",
    component: ContactsListComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "project-list-old",
    component: ProjectListComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "project-list",
    component: ProjectList2Component,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "project-search-list",
    component: ProjectList2Component,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "project/:id",
    component: ProjectDetailComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "pmfdl/:id/:project_id",
    component: PmfdlComponent,
    data: {
      layoutName: "layoutThree",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "contact/:id",
    component: ContactDetailComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "calendar",
    component: CalendarComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "edit-profile",
    component: EditProfileComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "files-list",
    component: FilesListComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "signins",
    component: SigninsListComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "claim/signin/:id",
    component: ClaimSigninComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "claim/marketing-list-entry/:id",
    component: ClaimMarketingListEntryComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },

  {
    path: "node/:id",
    component: NodeComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CoreRoutingModule {}
